export class Message {

  constructor(text, role, status, includedInContext, contextForAI = null) {
    this.text = text;
    this.role = role;
    this.status = status;
    this.includedInContext = includedInContext;
    this.contextForAI = contextForAI;  // Fill the "content" field if not null
  }
}